import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
const APPROVE_CAL_EVENTS_MAX = 100;
export const approveCalEventsInputSchema = z.object({
    eventIds: z
        .array(requiredUuidString('Event is required.', 'Invalid event ID.'))
        .min(1, 'Pick at least one event.')
        .max(APPROVE_CAL_EVENTS_MAX, `Approve at most ${APPROVE_CAL_EVENTS_MAX} events at a time.`)
        .refine((ids) => new Set(ids).size === ids.length, 'Each event can only be listed once.'),
});
//# sourceMappingURL=approve-cal-events-input.js.map